import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MultilingualService } from '@core/services';

@Component({
    selector: 'app-view-policy-details-dialog',
    templateUrl: './policy-details-dialog.component.html',
    styleUrls: ['./policy-details-dialog.component.scss'],
    standalone: false
})
export class PolicyDetailsDialogComponent implements OnInit {
  public activeFAQIndex!: number;

  constructor(
    public dialogRef: MatDialogRef<PolicyDetailsDialogComponent>,
    readonly multilingualService: MultilingualService,
    @Inject(MAT_DIALOG_DATA)
    public dialogData?: {
      type: 'privacy-policy' | 'terms-of-use' | 'FAQ';
      activeIndex: number;
    }
  ) {}
  
  ngOnInit(): void {
    if (this.dialogData?.activeIndex === undefined) {
      this.activeFAQIndex = 0;
    } else {
      this.activeFAQIndex = this.dialogData.activeIndex;
    }
  }
}
